/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_HakkimizdaInputs */

const tr_footer_link_hakkimizda = /** @type {(inputs: Footer_Link_HakkimizdaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakkımızda`)
};

const en_footer_link_hakkimizda = /** @type {(inputs: Footer_Link_HakkimizdaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Us`)
};

const de_footer_link_hakkimizda = /** @type {(inputs: Footer_Link_HakkimizdaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über uns`)
};

const ru_footer_link_hakkimizda = /** @type {(inputs: Footer_Link_HakkimizdaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О нас`)
};

/**
* | output |
* | --- |
* | "About Us" |
*
* @param {Footer_Link_HakkimizdaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const footer_link_hakkimizda = /** @type {((inputs?: Footer_Link_HakkimizdaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_HakkimizdaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_link_hakkimizda(inputs)
	if (locale === "de") return de_footer_link_hakkimizda(inputs)
	if (locale === "ru") return ru_footer_link_hakkimizda(inputs)
	return tr_footer_link_hakkimizda(inputs)
});